export default {
  "Adresse e-mail ou mot de passe incorrect.": "Incorrect email address or password.",
  "Votre adresse e-mail n'est pas encore confirmée : nous venons de vous envoyer un lien de confirmation. Consultez votre boîte de réception (et les courriers indésirables).": "Your email address is not confirmed yet: we've just sent you a confirmation link. Check your inbox (and spam folder).",
  "Un compte existe déjà avec cette adresse.": "An account already exists with this address.",
  "Le mot de passe doit contenir au moins 10 caractères.": "The password must be at least 10 characters long.",
  "Ce lien n'est plus valide. Faites une nouvelle demande.": "This link is no longer valid. Please make a new request.",
  "Une erreur est survenue. Réessayez.": "An error occurred. Please try again.",
  "Trop de tentatives. Patientez une minute avant de réessayer.": "Too many attempts. Wait a minute before trying again.",
  "Bon retour.": "Welcome back.",
  "Connectez-vous pour retrouver votre Copilote.": "Sign in to get back to your Copilot.",
  "Pas encore de compte ?": "No account yet?",
  "Adresse e-mail": "Email address",
  "Mot de passe": "Password",
  "Se souvenir de moi": "Remember me",
  "Mot de passe oublié ?": "Forgot password?",
  "Se connecter": "Sign in",
  "Trop de demandes. Réessayez dans quelques minutes.": "Too many requests. Try again in a few minutes.",
  "Mot de passe oublié.": "Forgot your password.",
  "Indiquez votre adresse : nous vous enverrons un lien de réinitialisation valable une heure.": "Enter your address: we'll send you a reset link valid for one hour.",
  "Retour à la connexion": "Back to sign in",
  "Si un compte existe pour": "If an account exists for",
  ", un e-mail vient d'être envoyé. Pensez à vérifier vos courriers indésirables.": ", an email has just been sent. Remember to check your spam folder.",
  "Envoyer le lien": "Send the link",
  "10 caractères minimum.": "10 characters minimum.",
  "Les deux mots de passe ne correspondent pas.": "The two passwords don't match.",
  "Mot de passe modifié. Toutes vos sessions ont été déconnectées par sécurité.": "Password changed. All your sessions have been signed out for security.",
  "Nouveau mot de passe.": "New password.",
  "Choisissez un mot de passe robuste, que vous n'utilisez nulle part ailleurs.": "Choose a strong password that you don't use anywhere else.",
  "Lien incomplet.": "Incomplete link.",
  "Refaire une demande": "Request a new link",
  "Nouveau mot de passe": "New password",
  "Confirmation": "Confirm",
  "Continuer avec Google": "Continue with Google",
  "Vérifiez votre boîte mail.": "Check your inbox.",
  "Nous avons envoyé un lien de confirmation à": "We sent a confirmation link to",
  "votre adresse": "your address",
  ". Cliquez dessus pour activer votre compte et commencer la configuration.": ". Click it to activate your account and start the setup.",
  "Patientez quelques minutes avant un nouvel envoi.": "Wait a few minutes before sending again.",
  "Envoi impossible.": "Unable to send.",
  "E-mail renvoyé.": "Email sent again.",
  "Renvoyer l'e-mail": "Resend the email",
  "Indiquez votre nom complet.": "Enter your full name.",
  "Adresse e-mail invalide.": "Invalid email address.",
  "Vous devez accepter les conditions pour continuer.": "You must accept the terms to continue.",
  "Créez votre Copilote.": "Create your Copilot.",
  "Deux minutes pour configurer un coach adapté à votre activité.": "Two minutes to set up a coach tailored to your business.",
  "Déjà inscrit ?": "Already registered?",
  "Nom complet": "Full name",
  "Adresse e-mail professionnelle": "Work email address",
  "J'accepte les": "I accept the",
  "conditions d'utilisation": "terms of use",
  "et la": "and the",
  "Créer mon compte": "Create my account",
  "Gère l'équipe, les invitations et toutes les données de l'espace.": "Manages the team, invitations and all workspace data.",
  "Crée et modifie les tâches, projets et documents de l'espace.": "Creates and edits the workspace's tasks, projects and documents.",
  "Consulte l'espace sans rien modifier.": "Views the workspace without changing anything.",
  "Espace d'équipe créé.": "Team space created.",
  "Nouvel espace d'équipe": "New team space",
  "Un espace partagé : tâches, projets, documents et finances communs. Votre espace personnel reste privé.": "A shared space: common tasks, projects, documents and finances. Your personal space stays private.",
  "Nom de l'espace": "Space name",
  "Ex. Studio GBC": "E.g. GBC Studio",
  "Créer et ouvrir": "Create and open",
  "Travaillez à plusieurs": "Work together",
  "Créez un espace d'équipe pour partager tâches, projets et documents, assigner le travail et suivre la charge de chacun. Votre espace personnel reste strictement privé.": "Create a team space to share tasks, projects and documents, assign work and track everyone's workload. Your personal space stays strictly private.",
  "Comment ça marche": "How it works",
  "1. Créez un espace d'équipe et invitez vos collaborateurs par e-mail.": "1. Create a team space and invite your colleagues by email.",
  "2. Basculez d'un espace à l'autre depuis le menu en haut à gauche.": "2. Switch between spaces from the menu at the top left.",
  "3. Assignez les tâches, commentez, suivez la charge et demandez au Copilote d'équipe une répartition.": "3. Assign tasks, comment, track workload and ask the team Copilot for a split.",
  "Nouvel espace": "New space",
  "Rôle de {0}": "{0}'s role",
  "Retirer {0}": "Remove {0}",
  "Retirer {0} de l'espace ? Ses tâches seront désassignées.": "Remove {0} from the space? Their tasks will be unassigned.",
  "Invitation envoyée.": "Invitation sent.",
  "Inviter un collaborateur": "Invite a colleague",
  "E-mail": "Email",
  "Rôle": "Role",
  "Envoyer l'invitation": "Send invitation",
  "Lien d'invitation (valable 7 jours, réservé à cette adresse) :": "Invitation link (valid 7 days, for this address only):",
  "Copier le lien": "Copy link",
  "Lien copié.": "Link copied.",
  "Invitations en attente": "Pending invitations",
  "Aucune invitation en attente.": "No pending invitations.",
  "· envoyée": "· sent",
  "Révoquer": "Revoke",
  "Charge de travail": "Workload",
  "Tâches ouvertes assignées et temps estimé restant.": "Open assigned tasks and estimated time remaining.",
  "{0} tâche(s) ouverte(s) sans responsable.": "{0} open task(s) without an assignee.",
  "ouverte(s) ·": "open ·",
  "h estimées ·": "h estimated ·",
  "terminée(s) en 7 j": "done in 7 days",
  "{0} en retard": "{0} overdue",
  "{0} bloquée(s)": "{0} blocked",
  "Copilote d'équipe": "Team Copilot",
  "Synthèse, tâches à risque et répartition suggérée — à partir des seules tâches de cet espace. Rien n'est réassigné automatiquement.": "Summary, tasks at risk and suggested split — based only on this space's tasks. Nothing is reassigned automatically.",
  "Analyser l'équipe": "Analyse the team",
  "Espace d'équipe": "Team space",
  "Vous êtes dans votre espace personnel. Ouvrez ou créez un espace d'équipe pour collaborer.": "You are in your personal space. Open or create a team space to collaborate.",
  "Votre rôle : {0}. {1}": "Your role: {0}. {1}",
  "Quitter cet espace d'équipe ?": "Leave this team space?",
  "Quitter": "Leave",
  "Membres": "Members",
  "Charge & Copilote": "Workload & Copilot",
  "Vues jour / semaine / mois": "Day / week / month views",
  "Événements récurrents et rappels": "Recurring events and reminders",
  "Planification IA (basique, avancée, priorités)": "AI planning (basic, advanced, priorities)",
  "Détection de surcharge, mode Deep Work": "Overload detection, Deep Work mode",
  "Google Calendar et Outlook (OAuth)": "Google Calendar and Outlook (OAuth)",
  "Tâches avec priorité 1–5, durées, dépendances": "Tasks with priority 1–5, durations, dependencies",
  "Projets et historique des modifications": "Projects and change history",
  "Replanification intelligente": "Smart rescheduling",
  "Outils du Coach : create_task, update_task…": "Coach tools: create_task, update_task…",
  "Transactions, catégories, filtres": "Transactions, categories, filters",
  "Import CSV avec prévisualisation et détection de doublons": "CSV import with preview and duplicate detection",
  "Prévisionnel de trésorerie 30/60/90 jours (3 scénarios)": "30/60/90-day cash flow forecast (3 scenarios)",
  "Détecteur de risques et simulateur de décisions": "Risk detector and decision simulator",
  "Devis, factures, propositions, contrats…": "Quotes, invoices, proposals, contracts…",
  "Génération IA contextuelle, versionnage": "Contextual AI generation, versioning",
  "Contrôle qualité avant export": "Quality check before export",
  "Dossiers, téléversement, prévisualisation": "Folders, upload, preview",
  "Stockage privé S3, quotas, liens temporaires": "Private S3 storage, quotas, temporary links",
  "Recherche sémantique (RAG) avec citations": "Semantic search (RAG) with citations",
  "Déclencheurs, conditions, actions": "Triggers, conditions, actions",
  "Validation humaine des actions sensibles": "Human approval of sensitive actions",
  "Journal d'exécution, suspension immédiate": "Run log, immediate pause",
  "Objectifs, indicateurs, jalons": "Goals, KPIs, milestones",
  "Score de progression transparent et configurable": "Transparent, configurable progress score",
  "Bilan hebdomadaire": "Weekly review",
  "Invitations, rôles et permissions": "Invitations, roles and permissions",
  "Projets et tâches partagés": "Shared projects and tasks",
  "Stripe (abonnements)": "Stripe (subscriptions)",
  "Architecture d'adaptateurs, OAuth, moindre privilège": "Adapter architecture, OAuth, least privilege",
  "Centre de notifications unifié": "Unified notification centre",
  "Rappels planifiés côté serveur (jobs persistants)": "Server-side scheduled reminders (persistent jobs)",
  "Préférences par type et fréquence": "Preferences by type and frequency",
  "Phase {0} de la feuille de route": "Roadmap phase {0}",
  "Module en cours de développement": "Module under development",
  "Ce module n'est pas encore disponible. Plutôt que d'afficher une maquette ou des données fictives, nous le livrerons lorsqu'il sera réellement fonctionnel et testé.": "This module isn't available yet. Rather than show a mock-up or fake data, we'll ship it once it's truly working and tested.",
  "En attendant, en parler au Coach IA": "Meanwhile, talk about it with the AI Coach",
  "Posts réseaux sociaux": "Social media posts",
  "5 publications prêtes à poster": "5 posts ready to publish",
  "Calendrier éditorial": "Content calendar",
  "30 jours de contenus planifiés": "30 days of planned content",
  "Client idéal": "Ideal customer",
  "Qui il est, où le trouver, quoi lui dire": "Who they are, where to find them, what to say",
  "Plan marketing 90 jours": "90-day marketing plan",
  "Actions semaine par semaine": "Week-by-week actions",
  "E-mails de prospection": "Prospecting emails",
  "Séquence de 3 e-mails": "3-email sequence",
  "Publicités": "Ads",
  "Facebook, Instagram et Google Ads": "Facebook, Instagram and Google Ads",
  "Slogans et pitch": "Slogans and pitch",
  "10 slogans + pitch de 30 secondes": "10 slogans + 30-second pitch",
  "Analyse d'offre et de prix": "Offer and pricing analysis",
  "Gamme à 3 niveaux, valeur perçue": "3-tier range, perceived value",
  "Fiche Google et avis": "Google profile and reviews",
  "Description, posts, réponses aux avis": "Description, posts, review replies",
  "Professionnel": "Professional",
  "Chaleureux": "Warm",
  "Inspirant": "Inspiring",
  "Humoristique": "Humorous",
  "Vous avez utilisé vos 3 créations offertes ce mois-ci. Passez à Essentiel pour créer sans limite.": "You've used your 3 free creations this month. Upgrade to Essential to create without limits.",
  "Croissance": "Growth",
  "Votre service marketing de poche : choisissez, décrivez votre offre, c'est prêt. Tout est enregistré dans Documents.": "Your pocket marketing department: choose, describe your offer, done. Everything is saved in Documents.",
  "Illimité": "Unlimited",
  "Votre offre": "Your offer",
  "Ce que vous vendez, pour qui, ce qui vous rend différent. Quelques phrases suffisent.": "What you sell, to whom, what makes you different. A few sentences are enough.",
  "Ex. : Je crée des sites vitrines pour les artisans du bâtiment, livrés en 7 jours, à partir de 900 €.": "E.g.: I build showcase websites for building tradespeople, delivered in 7 days, from €900.",
  "Cible (facultatif)": "Target (optional)",
  "Artisans, 35-55 ans, Lyon": "Tradespeople, aged 35-55, Lyon",
  "Réseau": "Network",
  "Ton": "Tone",
  "Créer «": "Create “",
  "Modifier / PDF": "Edit / PDF",
  "Astuce : demandez au": "Tip: ask the",
  "« Analyse mes ventes et propose-moi une campagne » : il s'appuie sur vos clients, devis et objectifs.": "“Analyse my sales and suggest a campaign”: it uses your customers, quotes and goals.",
  "Les contenus générés sont des propositions à relire avant publication.": "Generated content is a draft to review before publishing.",
  "Plateforme": "Platform",
  "Statistiques agrégées, formules et modules. Aucun contenu privé des utilisateurs (conversations, documents, finances) n'est accessible ici.": "Aggregated statistics, plans and modules. No private user content (conversations, documents, finances) is accessible here.",
  "Comptes": "Accounts",
  "{0} vérifiés": "{0} verified",
  "Nouveaux (7 j)": "New (7 d)",
  "Actifs (7 j)": "Active (7 d)",
  "Espaces d'équipe": "Team spaces",
  "Espaces par formule : {0}": "Spaces by plan: {0}",
  "Appels IA (30 jours)": "AI calls (30 days)",
  "Aucun appel": "No calls",
  "· automatisations 7 j :": "· automations 7 d:",
  "échec(s))": "failure(s))",
  "Appels IA par jour": "AI calls per day",
  "Appels": "Calls",
  "Formules": "Plans",
  "IA / jour": "AI / day",
  "Stockage": "Storage",
  "{0} Go": "{0} GB",
  "{0} Mo": "{0} MB",
  "Limites définies par variables d'environnement (AI_DAILY_LIMIT_PRO, FILE_QUOTA_PRO_MB…).": "Limits set by environment variables (AI_DAILY_LIMIT_PRO, FILE_QUOTA_PRO_MB…).",
  "Connecteurs (Google, Slack, Notion)": "Connectors (Google, Slack, Notion)",
  "À activer une seule fois, avec le guide pas à pas. Ensuite, chaque utilisateur se connecte avec son propre compte en un clic.": "Enable once, with the step-by-step guide. After that, each user connects their own account in one click.",
  "non activé": "not enabled",
  "activé": "enabled",
  "désactivé": "disabled",
  "Modifier": "Edit",
  "Activer": "Enable",
  "Rechercher un nom ou un e-mail": "Search a name or email",
  "Rechercher un compte": "Search for an account",
  " · non vérifié": " · unverified",
  "· inscrit": "· joined",
  "Formule de {0}": "{0}'s plan",
  "Attribuer la formule {0} à {1} ?": "Assign the {0} plan to {1}?",
  "Signalements de réponses IA": "AI answer reports",
  "Envoyés par les utilisateurs depuis le Coach (exigence App Store et Google Play : à traiter régulièrement).": "Sent by users from the Coach (App Store and Google Play requirement: review regularly).",
  "compte supprimé": "deleted account",
  "Statut du signalement": "Report status",
  "À traiter": "To review",
  "Traité": "Handled",
  "Sans suite": "No action",
  "Aucun signalement.": "No reports.",
  "Journal de sécurité": "Security log",
  "Aucun événement sensible.": "No sensitive events.",
  "Lancer une offre d'accompagnement premium et signer 5 clients d'ici fin décembre": "Launch a premium coaching offer and sign 5 clients by the end of December",
  "Préparer un salon professionnel dans 6 semaines (stand, supports, prospection)": "Prepare a trade show in 6 weeks (stand, materials, prospecting)",
  "Recruter mon premier collaborateur en alternance pour la rentrée": "Hire my first apprentice for the new school year",
  "Mission créée : {0} tâches ajoutées.": "Mission created: {0} tasks added.",
  "De l'idée à l'exécution": "From idea to execution",
  "Décrivez un objectif : le coach le transforme en mission complète — étapes, tâches, durées estimées, dépendances, risques et indicateurs. Vous ajustez tout avant de créer quoi que ce soit.": "Describe a goal: the coach turns it into a complete mission — steps, tasks, estimated durations, dependencies, risks and KPIs. You adjust everything before anything is created.",
  "Votre objectif": "Your goal",
  "Ex. Lancer ma nouvelle offre et signer 5 clients d'ici fin décembre": "E.g. Launch my new offer and sign 5 clients by the end of December",
  "Échéance (facultatif)": "Due date (optional)",
  "Vos réponses aux questions du coach (facultatif)": "Your answers to the coach's questions (optional)",
  "Puis régénérez le plan pour l'affiner.": "Then regenerate the plan to refine it.",
  "Régénérer le plan": "Regenerate the plan",
  "Générer la mission": "Generate the mission",
  "Le coach construit votre mission… (10 à 30 secondes)": "The coach is building your mission… (10 to 30 seconds)",
  "Nom de la mission": "Mission name",
  "tâches ·": "tasks ·",
  "de travail estimé (estimations à ajuster)": "of estimated work (estimates to adjust)",
  "Questions pour affiner le plan": "Questions to refine the plan",
  "Tâches proposées": "Proposed tasks",
  "Titre de la tâche {0}": "Title of task {0}",
  "Durée": "Duration",
  "J+": "D+",
  "après": "after",
  "Retirer la tâche {0}": "Remove task {0}",
  "Indicateurs de réussite": "Success indicators",
  "Risques": "Risks",
  "Hypothèses retenues": "Assumptions",
  "Documents utiles :": "Useful documents:",
  "(générables depuis le module Documents).": "(can be generated from the Documents module).",
  "Créer le projet et les": "Create the project and the",
  "tâches": "tasks",
  "Les échéances sont calculées à partir d'aujourd'hui (J+n).": "Due dates are calculated from today (D+n).",
  "Devis": "Quote",
  "Facture": "Invoice",
  "Proposition": "Proposal",
  "Contrat": "Contract",
  "Compte rendu": "Minutes",
  "Courrier": "Letter",
  "Rapport": "Report",
  "Brouillon": "Draft",
  "Finalisé": "Finalised",
  "Envoyé": "Sent",
  "Accepté": "Accepted",
  "Refusé": "Rejected",
  "Payée": "Paid",
  "Annulé": "Cancelled",
  "CA encaissé (12 mois)": "Revenue collected (12 months)",
  "À encaisser": "To collect",
  "Devis en attente": "Pending quotes",
  "CA total": "Total revenue",
  "Dernier paiement": "Last payment",
  "Dernier contact": "Last contact",
  "Il y a {0} j": "{0} d ago",
  "facture(s) en retard de paiement.": "invoice(s) overdue.",
  "Copilote de suivi client": "Customer follow-up Copilot",
  "État de la relation et prochaine meilleure action, à partir des seules données ci-dessous.": "Relationship status and next best action, based only on the data below.",
  "Analyser la relation": "Analyse the relationship",
} as Record<string, string>;
